import type { SxProps, Theme } from '@mui/material';

export const INPUT_LABEL_NUDGE = -8;

export const FORM_CONTROL_LABEL_ROW_SX: SxProps<Theme> = (theme) => ({
  display: 'flex',
  width: 'auto',
  boxSizing: 'border-box',
  margin: 0,
  marginInlineEnd: theme.spacing(1),
  flexWrap: 'wrap',
  columnGap: 0.25,
  rowGap: theme.spacing(0.25),
  '& .MuiRadio-root': {
    paddingInlineEnd: theme.spacing(0.25),
  },
  '&:last-of-type': { marginInlineEnd: 0 },
});

export const FORM_CONTROL_LABEL_VERTICAL_SX: SxProps<Theme> = (theme) => ({
  display: 'flex',
  width: '100%',
  boxSizing: 'border-box',
  margin: 0,
  flexWrap: 'nowrap',
  columnGap: 0.25,
  '& .MuiRadio-root': {
    paddingBlock: theme.spacing(0.5),
    paddingInlineEnd: theme.spacing(0.25),
  },
});
